import { PermissionCode } from "../enum/permission";

export const userMenuData = [
  {
    key: "dashboard",
    label: "پیشخوان",
    icon: "/assets/icons/Home.svg",
    permissions: [
      PermissionCode.getDashboardMapData,
      PermissionCode.getDashboardTopRiskAppVersion,
      PermissionCode.getDashboardEventCountPerEventTypeData,
      PermissionCode.getDashboardRiskPerDayData,
      PermissionCode.getDashboardTopRiskDevice,
    ],
  },
  {
    key: "report",
    label: "گزارش گیری",
    icon: "/assets/icons/Factor.svg",
    permissions: [
      PermissionCode.getReport,
      PermissionCode.getDistinctValueOfFiled,
      PermissionCode.createExport,
    ],
  },
  // {
  //   key: "export",
  //   label: "خروجی",
  //   icon: "/assets/icons/Folder.svg",
  //   permissions: [PermissionCode.getAllExports],
  // },
];

export const adminMenuData = [
  {
    key: "organization",
    label: "سازمان",
    icon: "/assets/icons/Personnel Card.svg",
    permissions: [
      PermissionCode.getAllConfigMap,
      PermissionCode.updateConfigMap,
      PermissionCode.getConfigMapByCode,
      PermissionCode.getAllConfigMap,
      PermissionCode.updateConfigMap,
      PermissionCode.getConfigMapByCode,
      PermissionCode.getAllRole,
      PermissionCode.deleteRole,
      PermissionCode.updateRole,
      PermissionCode.createNewRole,
      PermissionCode.getPermissionOfRole,
      PermissionCode.adminUserChangePasswordOfUser,
      PermissionCode.adminUserCreateNewUser,
      PermissionCode.adminUserGetAllUsers,
      PermissionCode.adminUserGetUserById,
      PermissionCode.adminUserUpdateUse,
      PermissionCode.getEventRiskById,
      PermissionCode.getAllEventRisk,
      PermissionCode.updateEventRisk,
      PermissionCode.getApplicationById,
      PermissionCode.getAllApplication,
      PermissionCode.createApplication,
      PermissionCode.getAllLogPlatform,
      PermissionCode.updateLogPlatform,
    ],
    Children: [
      {
        key: "org/profile",
        label: "پروفایل",
        icon: "",
        permissions: [
          PermissionCode.getAllConfigMap,
          PermissionCode.updateConfigMap,
          PermissionCode.getConfigMapByCode,
        ],
      },
      {
        key: "org/settings",
        label: "تنظیمات",
        icon: "",
        permissions: [
          PermissionCode.getAllConfigMap,
          PermissionCode.updateConfigMap,
          PermissionCode.getConfigMapByCode,
        ],
      },
      {
        key: "org/roles",
        label: "نقش ها",
        icon: "",
        permissions: [
          PermissionCode.getAllRole,
          PermissionCode.deleteRole,
          PermissionCode.updateRole,
          PermissionCode.createNewRole,
          PermissionCode.getPermissionOfRole,
        ],
      },
      {
        key: "org/users",
        label: "کاربران",
        icon: "",
        permissions: [
          PermissionCode.adminUserChangePasswordOfUser,
          PermissionCode.adminUserCreateNewUser,
          PermissionCode.adminUserGetAllUsers,
          PermissionCode.adminUserGetUserById,
          PermissionCode.adminUserUpdateUse,
        ],
      },
      {
        key: "org/risk-management",
        label: "مدیریت ریسک",
        icon: "",
        permissions: [
          PermissionCode.getEventRiskById,
          PermissionCode.getAllEventRisk,
          PermissionCode.updateEventRisk,
        ],
      },
    ],
  },
  {
    key: "app-management",
    label: "مدیریت اپلیکیشن ها",
    icon: "/assets/icons/Mobile.svg",
    permissions: [
      PermissionCode.getApplicationById,
      PermissionCode.getAllApplication,
      PermissionCode.createApplication,
    ],
  },
  {
    key: "log-setting",
    label: "تنظیمات لاگ",
    icon: "/assets/icons/Setting.svg",
    permissions: [
      PermissionCode.getAllLogPlatform,
      PermissionCode.updateLogPlatform,
    ],
  },
  {
    key: "alert",
    label: "تنظیمات هشدار ها",
    icon: "/assets/icons/Clipboard.svg",
    permissions: [
      PermissionCode.createAlertRule,
      PermissionCode.updateAlertRule,
      PermissionCode.getAllAlertRule,
      PermissionCode.createAlertReceiver,
      PermissionCode.updateAlertReceiver,
      PermissionCode.getAllAlertReceiver,
    ],
    Children: [
      {
        key: "alert/rule",
        label: "قوانین",
        icon: "",
        permissions: [
          PermissionCode.createAlertRule,
          PermissionCode.updateAlertRule,
          PermissionCode.getAllAlertRule,
        ],
      },
      {
        key: "alert/receiver",
        label: "گیرنده ها",
        icon: "",
        permissions: [
          PermissionCode.createAlertReceiver,
          PermissionCode.updateAlertReceiver,
          PermissionCode.getAllAlertReceiver,
        ],
      },
    ],
  },
];
